import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from 'src/app/core/service/base-service';
import { AuthUtilsService } from 'src/app/core/util/auth-utils.service';
import { PartyTypeModal } from '../modal/party-type-modal';

@Injectable({
  providedIn: 'root',
})
export class PartyTypeService extends BaseService<PartyTypeModal> {
  pagination: { pageIndex: number; perPage: number };
  constructor(http: HttpClient, authService: AuthUtilsService) {
    super(http, authService);
  }

  getModuleName(): string {
    return 'partyType';
  }

  validate(): boolean {
    return false;
  }
}
